angular
    .module("app")
    .controller("richiestaCessioneCtrl", function () {
        console.log("richiestaCessioneCtrl")
    }); 